import * as React from "react";

function SvgAlertCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm20 0a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.998a1 1 0 100-2 1 1 0 000 2zm1.004-12h-2.001v8h2v-8z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAlertCircle;
